// Lightweight helper module with no React/AgGrid dependencies
export function formatAmountIndian(value) {
  if (typeof value === "string") {
    const cleaned = value.replace(/[^\d.]/g, "");
    if (!cleaned || Number.isNaN(Number(cleaned))) {
      return value;
    }
    value = cleaned;
  }
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  if (num >= 10000000) {
    return (num / 10000000).toFixed(2) + " Cr";
  }
  if (num >= 100000) {
    return (num / 100000).toFixed(2) + " L";
  }
  return num.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      const base64Content = result.split(",")[1];
      resolve({
        filename: file.name,
        type: file.type,
        content: base64Content,
      });
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
